<template>
  <div class="allModalWrap">
    <div class="authModal">
      <div class="line">
        <span class="label">商户姓名：</span>
        <span>{{storeName}}</span>
        <span  class="label">商户ID：</span>
        <span>{{storeId}}</span>
      </div>
      <div class="line">
        <span class="label">是否同意：</span>
        <input  class="radio" type="radio" name="statu" value="y" v-model="status">是
        <input class="radio" type="radio" name="statu" value="n" v-model="status">否
      </div>
      <div class="line" v-show="status=='n'">
        <span class="label"> <i class="red">*</i> 拒绝理由：</span>
        <textarea name="" id="" cols="35" rows="3" v-model="rejectMemo"></textarea>
      </div>
      <div class="buttonsBox">
        <el-button @click='clickClose'>取 消</el-button>
        <el-button type="primary" @click='authSubmit'>提交</el-button>
      </div>
    </div>

  </div>

</template>

<script>
	import {	utils	} from '@/common/common.js'
	import { ajaxPost } from '@/common/request.js'
	export default {
		name: 'authmodal',
		data() {
			return {
        isShow:true,
        status:'',
        rejectMemo:'',
        storeId:'ces',
        storeName:'ces',
				// type:'',
				// reason:'',
				// infoObj:{},
				// isLoadingModal:"",

			}
		},
		props:['id','name'],
		components: {},
    watch:{
      name(newV,oldV) {
        console.log("检测到一次审核公司名称改变")
          this.storeName=newV
      },
      id(newV,oldV) {
          // do something
          this.storeId=newV
      },
    },
		computed: {
      adminId() {
        return utils.getAdminId()
      },
		},
		methods: {
      clickClose(){
        this.$emit('close');
      },
      refreshPage(){
        this.$emit("refreshPage")
      },
			refresh(){
				// this.$emit('submitSucess');
			},
			authSubmit(){
				let _this=this
        if(!this.status){
          _this.$message({
            message: "未选择审核结果",//接口返回一个页面
            type: 'warning',
            duration: 1500
          });
          return false
        }
        if(!this.rejectMemo&&_this.status=='n'){
          _this.$message({
            message: "拒绝时必须填拒绝理由",//接口返回一个页面
            type: 'warning',
            duration: 1500
          });
          return false
        }
        let args={
          status:_this.status,
          rejectMemo:_this.rejectMemo,
          storeId:_this.storeId,
          adminId:_this.adminId,
        }
        console.log(args)

        ajaxPost('/store/updateStatus',args).then(function(res){
          if(res.errorCode==200){
            _this.$message({
              message: "提交成功",//接口返回一个页面
              type: 'success',
              duration: 1500
            });
            _this.clickClose()
            _this.refreshPage()
          }else{
          }

        },function(res){
          _this.isLoadingModal=false
        })

			},
		},
		mounted() {
		}
	}
</script>

<style scoped lang="scss">
  .allModalWrap{
    position: fixed; top:0;bottom:0; left:0;right:0;  background: rgba(0,0,0,0.5);padding:20px; text-align: center;
    .radio{width: 30px;height:30px;vertical-align: middle;}
  }
	.authModal{
    margin-top:150px; position: relative;
    display: inline-block; width: 500px;height:300px;border:1px solid #ddd; text-align: left;padding:20px;background: #fff;
		.line{padding:0.2rem;}
		.content{display: inline-block;border:1px solid #eee; padding:0.1rem 0.1rem 0.1rem 0.3rem;min-width: 6rem;vertical-align: top;}
		.label{display: inline-block;background:#eee;color:#000;padding:0.1rem 0.2rem;}
		textarea{border:1px solid #aaa;padding:0.2rem;}
	}
  .buttonsBox{
    position: absolute;
    bottom:10px;right:10px;
    text-align: right;
  }

</style>



// WEBPACK FOOTER //
// src/components/authModal.vue